import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
};

const SizingIcon = ({ color = '#798588', size = 24, ...props }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 25 24"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.155 5.649c.66 0 1.196.535 1.196 1.196v15.958c0 .661-.535 1.197-1.196 1.197H1.197A1.197 1.197 0 0 1 0 22.803V6.845c0-.66.536-1.196 1.197-1.196Zm4.41-1.983a.237.237 0 0 1 .336 0l2.095 2.096a.236.236 0 0 1-.167.405H22.53v13.967h1.298a.237.237 0 0 1 .167.406l-2.095 2.095a.237.237 0 0 1-.336 0L19.47 20.54a.237.237 0 0 1 .168-.406h1.298V6.167h-1.298a.237.237 0 0 1-.168-.405Zm-5.607 4.376H2.394v13.564h13.564V8.042ZM17.98.018a.236.236 0 0 1 .258.052l2.096 2.095a.238.238 0 0 1 0 .336l-2.096 2.096a.236.236 0 0 1-.405-.168V3.131H3.866V4.43a.237.237 0 0 1-.406.168L1.365 2.5a.238.238 0 0 1 0-.336L3.46.07a.236.236 0 0 1 .406.167v1.298h13.967V.237c0-.096.058-.182.147-.219Z"
      fill={color}
      fillRule="nonzero"
    />
  </svg>
);

SizingIcon.propTypes = propTypes;

export default SizingIcon;
